import { FooterContainer } from './styles'
import logosFooter from '../../assets/svg/logosFooter.svg'
import { useLocation } from 'react-router-dom'
import { useIsMobileScreen } from 'hooks/useMediaQuery'
import packageJson from '../../../package.json';

const Footer = () => {
    const { pathname } = useLocation()
    const isMobile = useIsMobileScreen()
    if (isMobile && pathname === "/") {
        return null
    }
    return (
        !pathname.includes('login') && (
            <FooterContainer>
                <div className="text-xs  text-darkBlue">
                    <span>
                        2025 ©{' '}
                        <a
                            className="underline"
                            href="https://www.rededorsaoluiz.com.br/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Rede D'or
                        </a>
                    </span>

                    <p>versão {packageJson.version}</p>
                </div>

                <img src={logosFooter} alt="logos" />
            </FooterContainer>
        )
    )
}

export { Footer }
